import { FileText } from 'lucide-react'
import { cn } from '~/utils'

export const FileCardDisplay = ({ allowFileUpload }: { allowFileUpload?: boolean }) => {
  return (
    <div className={cn('bpComposerFileAttachement m-2', { '!hidden': !allowFileUpload })}>
      <div className="bpComposerFileIconWrapper">
        <FileText className="bpComposerFileIcon" />
      </div>
      <div className="bpComposerFileMetadata justify-center space-y-1 pr-1">
        <div className="bpComposerFileName h-3.5 w-16 rounded-full bg-[var(--bpGray-200)]" />
        <div className="bpComposerFileType h-3.5 w-8 rounded-full bg-[var(--bpGray-200)]" />
      </div>
    </div>
  )
}
